<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="pb-0 col-sm-12 d-flex mainDiv">
          <div class="col-sm-12 col-xs-12">
            <div
              class="col-sm-12 col-xs-12 titleDiv CertListTitle justify-content-between title-area"
            >
              <div>
                <h3>구독 관리 (v2)</h3>
                <h5>통합 구독 시스템을 통해 모든 구독을 관리합니다.</h5>
              </div>
              <div class="title-actions">
                <a-button
                  type="primary"
                  class="yellow-button"
                  @click="navigateToCreate"
                >
                  <i class="fa-solid fa-plus" />
                  구독 추가
                </a-button>
              </div>
            </div>

            <div class="filter-section">
              <div class="filter-row">
                <div class="filter-item">
                  <label>거래처명</label>
                  <a-input
                    v-model:value="filters.companyName"
                    placeholder="거래처명 검색"
                    allow-clear
                    @pressEnter="handleSearch"
                  />
                </div>
                <div class="filter-item">
                  <label>상품명</label>
                  <a-input
                    v-model:value="filters.packageName"
                    placeholder="상품명 검색"
                    allow-clear
                    @pressEnter="handleSearch"
                  />
                </div>
                <div class="filter-item">
                  <label>구독 상태</label>
                  <a-select
                    v-model:value="filters.status"
                    placeholder="전체"
                    allow-clear
                    style="width: 100%"
                  >
                    <a-select-option
                      v-for="(label, key) in ResellerSubscriptionStatusLabel"
                      :key="key"
                      :value="key"
                    >
                      {{ label }}
                    </a-select-option>
                  </a-select>
                </div>
                <div class="filter-item">
                  <label>결제 주기</label>
                  <a-select
                    v-model:value="filters.paymentCycle"
                    placeholder="전체"
                    allow-clear
                    style="width: 100%"
                  >
                    <a-select-option
                      v-for="(label, key) in PaymentCycleLabel"
                      :key="key"
                      :value="key"
                    >
                      {{ label }}
                    </a-select-option>
                  </a-select>
                </div>
                <div class="filter-actions">
                  <a-button
                    type="primary"
                    class="yellow-button"
                    @click="handleSearch"
                    >검색</a-button
                  >
                  <a-button @click="handleReset">초기화</a-button>
                </div>
              </div>
            </div>

            <div class="table-info">
              <div class="total-count">
                전체 <span>{{ pagination.total }}</span
                >건
              </div>
              <div class="table-actions">
                <a-select
                  v-model:value="pagination.pageSize"
                  @change="handleSearch"
                >
                  <a-select-option :value="10">10개씩</a-select-option>
                  <a-select-option :value="20">20개씩</a-select-option>
                  <a-select-option :value="50">50개씩</a-select-option>
                </a-select>
              </div>
            </div>

            <div class="table-container">
              <a-table
                :columns="columns"
                :data-source="subscriptions"
                :loading="loading"
                :pagination="false"
                :row-key="(record) => record._id || record.id"
                bordered
                size="small"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'companyName'">
                    <a
                      @click="navigateToDetail(record._id || record.id)"
                      class="company-link"
                    >
                      {{ record.companyName }}
                    </a>
                    <div v-if="record.businessNumber" class="business-number">
                      {{ formatBusinessNumber(record.businessNumber) }}
                    </div>
                  </template>

                  <template v-else-if="column.key === 'packageName'">
                    <div class="package-info">
                      <span class="package-name">{{ record.packageName }}</span>
                      <a-tag
                        :color="PaymentCycleColor[record.paymentCycle]"
                        size="small"
                      >
                        {{ PaymentCycleLabel[record.paymentCycle] }}
                      </a-tag>
                    </div>
                  </template>

                  <template v-else-if="column.key === 'finalUsageFee'">
                    <div class="price-cell">
                      <span class="price">{{
                        formatPrice(record.finalUsageFee)
                      }}</span>
                      <span v-if="record.discountType" class="discount-badge">
                        <a-tag color="orange" size="small">
                          {{
                            record.discountType === "PERCENTAGE"
                              ? `${record.discountValue}%`
                              : formatPrice(record.discountValue)
                          }}
                          할인
                        </a-tag>
                      </span>
                    </div>
                  </template>

                  <template v-else-if="column.key === 'status'">
                    <a-tag
                      :color="ResellerSubscriptionStatusColor[record.status]"
                    >
                      {{ ResellerSubscriptionStatusLabel[record.status] }}
                    </a-tag>
                    <a-tag
                      v-if="record.paymentStatus === 'OVERDUE'"
                      color="red"
                      size="small"
                      style="margin-left: 4px"
                    >
                      미납
                    </a-tag>
                  </template>

                  <template v-else-if="column.key === 'period'">
                    <div v-if="record.paymentCycle === 'ONCE'">
                      {{ formatDate(record.contractDate) || "-" }}
                    </div>
                    <div v-else>
                      {{ formatDate(record.startDate) }} ~
                      {{ formatDate(record.endDate) || "무제한" }}
                    </div>
                  </template>

                  <template v-else-if="column.key === 'completedRounds'">
                    <span>{{ record.completedRounds || 0 }}회</span>
                  </template>

                  <template v-else-if="column.key === 'actions'">
                    <a-space>
                      <a-button
                        size="small"
                        @click="navigateToDetail(record._id || record.id)"
                      >
                        상세
                      </a-button>
                      <a-button
                        size="small"
                        type="primary"
                        @click="navigateToEdit(record._id || record.id)"
                      >
                        수정
                      </a-button>
                      <a-popconfirm
                        title="이 구독을 삭제하시겠습니까?"
                        ok-text="삭제"
                        cancel-text="취소"
                        @confirm="handleDelete(record._id || record.id)"
                      >
                        <a-button size="small" danger>삭제</a-button>
                      </a-popconfirm>
                    </a-space>
                  </template>
                </template>
              </a-table>

              <div
                v-if="!loading && subscriptions.length === 0"
                class="empty-state"
              >
                <i class="fa-solid fa-inbox" />
                <p>등록된 구독이 없습니다.</p>
              </div>
            </div>

            <div class="pagination-container">
              <a-pagination
                v-model:current="pagination.current"
                :total="pagination.total"
                :page-size="pagination.pageSize"
                show-size-changer
                show-quick-jumper
                @change="handlePageChange"
                @showSizeChange="handlePageSizeChange"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { message } from "ant-design-vue";
import { resellerSubscriptionApi } from "./api";
import {
  ResellerSubscriptionStatusLabel,
  ResellerSubscriptionStatusColor,
  PaymentCycleLabel,
  PaymentCycleColor,
} from "./enums";
import {
  formatPrice,
  formatDate,
  formatBusinessNumber,
} from "./utils/formatters";

export default {
  name: "SubscriptionManagementV2",
  setup() {
    const router = useRouter();
    const loading = ref(false);
    const subscriptions = ref([]);

    const filters = reactive({
      companyName: "",
      packageName: "",
      status: undefined,
      paymentCycle: undefined,
    });

    const pagination = reactive({
      current: 1,
      pageSize: 10,
      total: 0,
    });

    const columns = [
      {
        title: "거래처",
        key: "companyName",
        dataIndex: "companyName",
        width: 180,
      },
      {
        title: "상품명",
        key: "packageName",
        dataIndex: "packageName",
        width: 200,
      },
      {
        title: "사용료",
        key: "finalUsageFee",
        dataIndex: "finalUsageFee",
        width: 150,
        align: "right",
      },
      {
        title: "상태",
        key: "status",
        dataIndex: "status",
        width: 120,
        align: "center",
      },
      { title: "계약기간", key: "period", width: 200, align: "center" },
      {
        title: "결제회차",
        key: "completedRounds",
        dataIndex: "completedRounds",
        width: 80,
        align: "center",
      },
      {
        title: "작업",
        key: "actions",
        width: 180,
        align: "center",
        fixed: "right",
      },
    ];

    const fetchSubscriptions = async () => {
      loading.value = true;
      try {
        const params = {
          page: pagination.current,
          limit: pagination.pageSize,
          ...(filters.companyName && { companyName: filters.companyName }),
          ...(filters.packageName && { packageName: filters.packageName }),
          ...(filters.status && { status: filters.status }),
          ...(filters.paymentCycle && { paymentCycle: filters.paymentCycle }),
        };

        const response = await resellerSubscriptionApi.getList(params);
        subscriptions.value = response.docs || response.data || [];
        pagination.total = response.totalDocs || response.total || 0;
      } catch (error) {
        console.error("구독 목록 조회 실패:", error);
        message.error("구독 목록을 불러오는데 실패했습니다.");
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.current = 1;
      fetchSubscriptions();
    };

    const handleReset = () => {
      filters.companyName = "";
      filters.packageName = "";
      filters.status = undefined;
      filters.paymentCycle = undefined;
      pagination.current = 1;
      fetchSubscriptions();
    };

    const handlePageChange = (page) => {
      pagination.current = page;
      fetchSubscriptions();
    };

    const handlePageSizeChange = (current, size) => {
      pagination.pageSize = size;
      pagination.current = 1;
      fetchSubscriptions();
    };

    const handleDelete = async (id) => {
      try {
        await resellerSubscriptionApi.delete(id);
        message.success("구독이 삭제되었습니다.");
        fetchSubscriptions();
      } catch (error) {
        console.error("구독 삭제 실패:", error);
        message.error("구독 삭제에 실패했습니다.");
      }
    };

    const navigateToCreate = () => {
      router.push("/subscriptions-v2/create");
    };

    const navigateToDetail = (id) => {
      router.push(`/subscriptions-v2/${id}`);
    };

    const navigateToEdit = (id) => {
      router.push(`/subscriptions-v2/${id}/edit`);
    };

    onMounted(() => {
      fetchSubscriptions();
    });

    return {
      loading,
      subscriptions,
      filters,
      pagination,
      columns,
      ResellerSubscriptionStatusLabel,
      ResellerSubscriptionStatusColor,
      PaymentCycleLabel,
      PaymentCycleColor,
      formatPrice,
      formatDate,
      formatBusinessNumber,
      handleSearch,
      handleReset,
      handlePageChange,
      handlePageSizeChange,
      handleDelete,
      navigateToCreate,
      navigateToDetail,
      navigateToEdit,
    };
  },
};
</script>

<style lang="scss" scoped>
.row {
  padding: 28px 28px 72px 28px !important;
}

.title-area {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;

  h3 {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #17191c;
  }

  h5 {
    margin: 8px 0 0;
    font-size: 14px;
    font-weight: 400;
    color: #666;
  }
}

.title-actions {
  display: flex;
  gap: 8px;
}

.filter-section {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  border: 1px solid #e5e7eb;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
}

.filter-item {
  flex: 1;
  min-width: 180px;
  max-width: 220px;

  label {
    display: block;
    margin-bottom: 6px;
    font-size: 13px;
    font-weight: 500;
    color: #374151;
  }
}

.filter-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}

.table-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.total-count {
  font-size: 14px;
  color: #666;

  span {
    font-weight: 600;
    color: #1890ff;
  }
}

.table-actions {
  display: flex;
  gap: 8px;
}

.table-container {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.company-link {
  color: #1890ff;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.business-number {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.package-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.package-name {
  font-weight: 500;
}

.price-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}

.price {
  font-weight: 600;
}

.discount-badge {
  margin-top: 2px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;

  i {
    font-size: 48px;
    margin-bottom: 16px;
  }

  p {
    font-size: 16px;
    margin: 0;
  }
}

.pagination-container {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.yellow-button {
  background-color: #ffe414 !important;
  border-color: #ffe414 !important;
  color: #17191c !important;
  font-weight: 600;

  &:hover {
    background-color: #ffd900 !important;
    border-color: #ffd900 !important;
  }

  i {
    margin-right: 6px;
  }
}

@media screen and (max-width: 768px) {
  .filter-row {
    flex-direction: column;
  }

  .filter-item {
    max-width: 100%;
  }

  .filter-actions {
    margin-left: 0;
    width: 100%;
    justify-content: flex-end;
  }

  .title-area {
    flex-direction: column;
    gap: 16px;
  }
}
</style>
